
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const ThankYouPage = () => {
  const location = useLocation();
  const { message, status } = location.state || {};

  useEffect(() => {
    if (message) {
      toast.success(message);
    }

    // Create animated particles
    const container = document.querySelector('.particles');
    const colors = ['#4ade80', '#60a5fa', '#fbbf24', '#f472b6'];
    
    for (let i = 0; i < 50; i++) {
      const particle = document.createElement('div');
      particle.className = 'particle absolute rounded-full';
      
      // Random properties
      const size = Math.random() * 10 + 5;
      const posX = Math.random() * 100;
      const posY = Math.random() * 100;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const duration = Math.random() * 10 + 10;
      const delay = Math.random() * 5;
      
      particle.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${posX}%;
        top: ${posY}%;
        background-color: ${color};
        animation: float ${duration}s ease-in-out ${delay}s infinite;
        opacity: ${Math.random() * 0.5 + 0.2};
      `;
      
      container?.appendChild(particle);
    }

    return () => {
      // Cleanup particles when component unmounts
      const particles = document.querySelectorAll('.particle');
      particles.forEach(particle => particle.remove());
    };
  }, [message]);

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-blue-50 via-green-50 to-purple-50">
      {/* Animated background particles */}
      <div className="particles absolute inset-0 w-full h-full pointer-events-none"></div>
      
      {/* Confetti animation elements */}
      <div className="confetti absolute inset-0 w-full h-full pointer-events-none overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div 
            key={i}
            className="confetti-piece absolute"
            style={{
              background: ['#4ade80', '#60a5fa', '#fbbf24', '#f472b6'][Math.floor(Math.random() * 4)],
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 10 + 5}px`,
              height: `${Math.random() * 10 + 5}px`,
              opacity: Math.random() * 0.5 + 0.5,
              animation: `drop ${Math.random() * 3 + 2}s linear ${Math.random() * 2}s infinite`,
              transform: `rotate(${Math.random() * 360}deg)`
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center transform transition-all duration-500 hover:scale-105">
          <h1 className="text-3xl font-bold text-green-600 mb-4 animate-bounce">
            Thank You For Your Response!
          </h1>
          <p className="text-lg mb-6">
            The document has been {status || 'processed'} successfully.
          </p>
          <div className="w-20 h-20 mx-auto mb-6">
            <svg 
              className="w-full h-full text-green-500 animate-checkmark" 
              viewBox="0 0 52 52"
            >
              <circle 
                className="stroke-current text-green-100" 
                cx="26" 
                cy="26" 
                r="25" 
                fill="none" 
                strokeWidth="2"
              />
              <path 
                className="stroke-current" 
                fill="none" 
                strokeWidth="4" 
                strokeLinecap="round" 
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
         
        </div>
      </div>

      {/* CSS animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) translateX(0);
          }
          25% {
            transform: translateY(-20px) translateX(10px);
          }
          50% {
            transform: translateY(0) translateX(20px);
          }
          75% {
            transform: translateY(20px) translateX(10px);
          }
        }
        
        @keyframes drop {
          0% {
            top: -10%;
            opacity: 1;
          }
          100% {
            top: 100%;
            opacity: 0;
          }
        }
        
        @keyframes checkmark {
          0% {
            stroke-dashoffset: 100;
            opacity: 0;
          }
          100% {
            stroke-dashoffset: 0;
            opacity: 1;
          }
        }
        
        .animate-checkmark path {
          animation: checkmark 1s ease-in-out forwards;
          stroke-dasharray: 100;
          stroke-dashoffset: 100;
        }
      `}</style>
    </div>
  );
};

export default ThankYouPage;